import type { GetApiV1ThreeLetterCodePartnerAdminsUsersUserId200 } from '@fukuri-admins/apis/client/gen/model';
import type { EditUserFormBankAccountFieldValues } from '../schema';

type IConvertToFormValues = (
  data: GetApiV1ThreeLetterCodePartnerAdminsUsersUserId200
) => EditUserFormBankAccountFieldValues;

/**
 * API レスポンスを利用者編集フォーム（口座連携版）の初期値に変換する
 *
 * - billable_from（'YYYY-MM-DD' 文字列）は Date に変換（DatePicker 用）
 *
 * @param data - GET /partner_admins/users/:userId のレスポンス
 * @returns useForm の defaultValues に渡す値
 */
export const convertToFormValues: IConvertToFormValues = data => ({
  fullName: data.user.full_name,
  email: data.user.email ?? '',
  externalUserId: data.user.external_user_id ?? '',
  password: '',
  passwordConfirmation: '',
  billableFrom: data.user.billable_from ? new Date(data.user.billable_from) : null,
});
